
import { defineComponent, PropType, ref, watch, getCurrentInstance } from "vue";
import type { CheckoutType } from "@/components/alp-components/alp-check/checkout";
// 类型检测
function typeString(obj) {
  var str = Object.prototype.toString.call(obj).replace(/[\[\]]/g, "");
  return str.split(" ")[1];
}
export default defineComponent({
  name: "checkout",
  props: {
    data: [String, Number],
    rule: Array,
    type: {
      type: String as PropType<CheckoutType>,
      default: "input",
    },
    options: Array,
    format: String,
    params: Object,
    iptDisabled: Boolean,
    disabledFun: {
      type: [Boolean, Function],
      default: false,
    },
    disMsg: String,
    rowData: Object,
    keyValue: [Object, String],
  },
  data() {
    return {
      // 绑定数据
      value: "",
      // 错误信息
      errorMsg: "",
      // 校验状态
      checkStatus: true,
      formatData: "",
    };
  },
  inject: ["reactiveData"],
  watch: {
    data: function (data) {
      this.init();
    },
    value: function (val) {
      let value: unknown = null;
      switch (this.type) {
        case "select":
           //选择框统一处理字符串
          var typeMap = ["[object Undefined]", "[object Null]"];
          if (Array.isArray(val)) {
            val.forEach((o, i) => {
              var oTypeStr = Object.prototype.toString.call(o);
              value = typeMap.indexOf(oTypeStr) != -1 ? undefined : "" + o;
            });
          } else {
            var typeStr = Object.prototype.toString.call(val);
            value = typeMap.indexOf(typeStr) != -1 ? undefined : "" + val;
          }
          break;
        case "date":
          value = this.format
            ? (new Date(val) as any).Format(this.formatData)
            : val;
          break;
        case "checkBox":
          value = val ? "Y" : "N";
          break;
        default:
          value = val;
      }
      // 更新数据
      this.$emit("update:data", value);
    },
  },
  mounted() {
    if (this.format) {
      this.formatData = this.format.replaceAll("D", "d");
    }
    this.init();
  },
  methods: {
    // 初始化
    init: function () {
      let value: unknown = null;
      switch (this.type) {
        case "checkBox":
          value = this.data === "Y";
          break;
        default:
          value = this.data;
      }
      (this as any).value = value;
      if (Array.isArray(this.rule) && (this as any).rule.length) {
        (this as any).reactiveData.addForm({
          func: this.check,
          keys: this.keyValue,
        });
      }
      if (this.params && Array.isArray(this.options) && this.options.length) {
        (this as any).options.forEach((item) => {
          item.value = item[(this as any).params.value];
          item.label = item[(this as any).params.label];
        });
      }
    },
    //禁用
    disabledF() {
      if (typeString(this.disabledFun) === "Function") {
        return (this as any).disabledFun(this.rowData, this.value);
      } else {
        return this.disabledFun || false;
      }
    },
    //弹窗选择器点击
    modalClick() {
      this.$emit("modalClick", this.rowData, (res) => {
        //校验
        this.check();
      });
    },
    // 校验
    checkRule: function () {
      return new Promise((resolve, reject) => {
        if (Array.isArray(this.rule) && this.rule.length) {
          const rules = (this as any).rule;
          let flag = true;
          for (let i = 0; i < rules.length; i++) {
            if (
              "required" in rules[i] &&
              !this.checkItem("required", this.value, rules[i])
            ) {
              reject(rules[i].message);
              flag = false;
              break;
            }
            if (
              "max" in rules[i] &&
              !this.checkItem("max", this.value, rules[i])
            ) {
              reject(rules[i].message);
              flag = false;
              break;
            }
            if (
              "min" in rules[i] &&
              !this.checkItem("min", this.value, rules[i])
            ) {
              reject(rules[i].message);
              flag = false;
              break;
            }
            if (
              "validator" in rules[i] &&
              !this.checkItem("validator", this.value, rules[i])
            ) {
              reject(rules[i].message);
              flag = false;
              break;
            }
          }
          if (flag) {
            resolve(true);
          }
        } else {
          resolve(true);
        }
      });
    },
    checkItem: function (type, value, rule) {
      switch (type) {
        case "required":
          return (
            rule.required &&
            value !== undefined &&
            value !== null &&
            value !== ""
          );
        case "max":
          return (
            value !== undefined &&
            value !== null &&
            typeof value === "number" &&
            value < (rule.max || 0)
          );
        case "min":
          return (
            value !== undefined &&
            value !== null &&
            typeof value === "number" &&
            value > (rule.min || 0)
          );
        case "validator":
          return rule.validator(value);
      }
    },
    //
    check: function () {
      return this.checkRule()
        .then((err) => {
          this.errorMsg = "";
          this.checkStatus = true;
          return true;
        })
        .catch((err) => {
          this.errorMsg = err;
          this.checkStatus = false;
          return false;
        });
    },
    // 下拉选中事件
    originSelectChange: function (e) {
      const value = e.target.value;
      if (value) {
        this.value = value;
      }
    },
  },
});
